// extracted by mini-css-extract-plugin
export default {"wrapperBatchRibbon":"styles_wrapperBatchRibbon__xVzOP"};